export default __webpack_public_path__ + "static/media/45.deda7f3a.png";